const TARGET_TICKS = 5;

function getNiceStepSize(rawStep) {
  const exponent = Math.floor(Math.log10(rawStep));
  const fraction = rawStep / 10 ** exponent;

  let niceFraction = 10;
  if (fraction <= 1) niceFraction = 1;
  else if (fraction <= 2) niceFraction = 2;
  else if (fraction <= 5) niceFraction = 5;

  return niceFraction * 10 ** exponent;
}

export default function getBarChartYAxisScale(data) {
  const max = Math.max(0, ...(data ?? []).map((value) => Number(value) || 0));

  if (max === 0) {
    return { max: TARGET_TICKS, stepSize: 1 };
  }

  const stepSize = getNiceStepSize(max / TARGET_TICKS);
  const roundedMax = Math.ceil(max / stepSize) * stepSize;

  return { max: roundedMax, stepSize };
}
